module.exports = __webpack_public_path__ + "img/fish-prep-counter.76029f8f.jpg";